
import { css } from 'lit';
export default css`
pc-topic-card pc-heading{
    transition:all 0.3s ease 0s;
    margin-bottom:var(--spacing-2);
    color:var(--primary-eggplant);
  }

  pc-topic-card pc-wysiwyg{
    --wysiwyg-font-color:var(--neutral-medium-gray);
    transition:all 0.3s ease 0s;
    margin-bottom:var(--spacing-6);
  }

  @media (min-width: 992px){

  pc-topic-card pc-wysiwyg{
      margin-bottom:var(--spacing-8)
  }
    }

  pc-topic-card:hover pc-heading{
      border-color:var(--neutral-light);
      background:var(--neutral-light);
    }

  pc-topic-card:hover pc-wysiwyg{
      --wysiwyg-font-color:var(--neutral-charcoal);
    }`;